import { render, staticRenderFns } from "./FulfillmentReports.vue?vue&type=template&id=9aa5afe6"
import script from "./FulfillmentReports.vue?vue&type=script&lang=js"
export * from "./FulfillmentReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports